












import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import Icon, { IconEnum } from '@/modules/shared/components/icon.component.vue';


export { IconEnum };

export interface RankingCircleOption {
    position: number;
    name: string;
    icon: IconEnum;
    active: boolean;
}


@Component({
    components: {
        Icon,
    },
})
export default class RankingCircle extends Vue {
    @Prop() private option!: RankingCircleOption;
}
